import { dsClass } from '../../common/constants/dsClasses.js';
import { ModelType, OfferType } from '../../common/enums.js';
import {
  mobileBroadbandInfoMsg,
  mobileM2MMsg,
  t,
  voiceHeaderMsg,
  voiceSubscriptionsMsg,
} from '../../common/i18n/index.js';
import type { OfferAndModelType } from '../../common/types/productOfferings.js';
import type { ReactNode } from 'react';

import './CardSelectionHeader.scss';

interface CardSelectionHeaderProps {
  description: ReactNode;
  header: string;
  icon: string;
}

const VoiceDescription = () => <p>{t.OA7G(voiceHeaderMsg)}</p>;

const getIconDataByOnlineModelType = (type: OfferAndModelType): CardSelectionHeaderProps | undefined => {
  switch (type) {
    case ModelType.MobileBroadband:
      return {
        icon: 'picto-mobilebb',
        header: t.J1F7('Mobile broadband for companies'),
        description: t.SDV1(mobileBroadbandInfoMsg),
      };
    case OfferType.VOICE:
    case ModelType.VoiceSME:
    case ModelType.YrityspuheUusi:
      return {
        icon: 'picto-sim',
        header: t.ARE0(voiceSubscriptionsMsg),
        description: <VoiceDescription />,
      };
    // In COCO project for MOBILE_BROADBAND we are using the same header and description as for MOBILE_M2M, so we can group them together here
    case OfferType.MOBILE_BROADBAND:
    case ModelType.MobileM2M:
      return {
        icon: 'picto-broadband-m2m',
        header: t.A7CA(mobileM2MMsg),
        description: t.A7CB('Laitenetti is a good choice for your IP cameras, security systems and heating devices.'),
      };
    default:
      return undefined;
  }
};

export const CardSelectionHeader = ({ onlineModelType }: { onlineModelType: OfferAndModelType }) => {
  const headerData = getIconDataByOnlineModelType(onlineModelType);

  if (!headerData) {
    return null;
  }
  return (
    <div className="card-selection-header">
      <div className="icon">
        <div className={`picto ${headerData.icon}`}></div>
      </div>
      <div className="text">
        <h1 className={`${dsClass.H1} ${dsClass.MARGIN_VERTICAL_0} ${dsClass.PADDING_BOTTOM_2}`}>
          {headerData.header}
        </h1>
        <div className={dsClass.MARGIN_VERTICAL_0}>{headerData.description}</div>
      </div>
    </div>
  );
};
